import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo MachineController (api/machine): POS terminals of one company (DeptCode is mandatory).
const enc = encodeURIComponent;

const queryPager = (query) =>
	Client.post('/api/machine/query-pager', {
		...PAGE_ALL,
		...(query || {}),
	}).then(pagerRows);
const get = (pid) => Client.get(`/api/machine/one/${enc(pid)}`);
const create = (dto) => Client.post('/api/machine', dto);
const update = (pid, dto) => Client.put(`/api/machine/${enc(pid)}`, dto);
// Clears the device binding (komodo exposes it as a GET).
const unbind = (pid) => Client.get(`/api/machine/unbind/${enc(pid)}`);

export default { queryPager, get, create, update, unbind };
